export const PORTFOLIO = {
  title: 'Portfolio',
  subtitle: 'My',
  typeWriter: ['Best Works', 'Latest Projects'],
  github: 'https://github.com/MosabbirAhamed',
  types: ['All', 'Website'],
  projects: [
    {
      title: 'Furniture e-commerce Website',
      description:
        'I design Furniture application with ReactJS. This website is lots of functionality. On this website almost all content is dynamic.',
      video: null,
      images: {
        default: '/Asset/portfolio/furniture-main.jpg',
        variants: [
          '/Asset/portfolio/furniture-3.jpg',
          '/Asset/portfolio/furniture-2.png',
        ],
      },
      link: 'https://future-of-furniture.netlify.app/',
      type: 'Website',
      tags: ['Web Design', 'Mobile Apps'],
      source:'https://github.com/MosabbirAhamed/Future-Of-Furniture',
    },

    {
      title: 'Movie App',
      description:
        'This is a movie all where you can watch, download movies',
      video: null,
      images: {
        default: '/Asset/portfolio/netflix-main.jpg',
        variants: [
          '/Asset/portfolio/netflix.jpg',
          '/Asset/portfolio/netflix.jpg',
        ],
      },
      link: 'https://netfilx-beta.netlify.app/',
      source:'https://github.com/MosabbirAhamed/Little-Netflix',
      type: 'Website',
      tags: ['Web Design','Mobile Apps'],
    },
    {
      title: 'Zomato Clone',
      description:
        ' I bulid Zomato clone application with React.js. This website is lots of functionality. On this website almost all content is dynamic.',
      video: null,
      images: {
        default: '/Asset/portfolio/zomato-main.jpg',
        variants: [
          '/Asset/portfolio/zomato-2.jpg',
          '/Asset/portfolio/zomato-3.jpg',
        ],
      },
      link: 'https://zomato-clone-by-mosabbir.netlify.app/',
      source:'https://github.com/MosabbirAhamed/Zomato-Clone',
      type: 'Website',
      tags: ['Web Design', 'Mobile Apps'],
    },
    {
      title: 'RESTAURANT Website',
      description:
        ' I design RESTAURANT application with Html, Css, JavaScript. On this website almost all content is dynamic.',
      video: null,
      images: {
        default: '/Asset/portfolio/resturent.jpg',
        variants: [
          '/Asset/portfolio/resturent-2.jpg',
          '/Asset/portfolio/resturent-2.jpg',
        ],
      },
      link: 'https://mosabbirahamed.github.io/RESTAURANT/',
      source:'https://github.com/MosabbirAhamed/RESTAURANT',
      type: 'Website',
      tags: ['Web Design', 'Mobile Apps'],
    },
    {
      title: 'TODO App',
      description:
        ' I bulid TODO application with Html, Css, JavaScript. This application is lots of functionality.',
      video: null,
      images: {
        default: '/Asset/portfolio/todo.png',
        variants: [
          '/Asset/portfolio/todo.png',
          '/Asset/portfolio/todo.png',
        ],
      },
      link: 'https://mosabbirahamed.github.io/TODO/',
      source:'https://github.com/MosabbirAhamed/TODO',
      type: 'Website',
      tags: ['Web Design', 'Mobile Apps'],
    },
    {
      title: 'Temperature Converter',
      description:
        ' I bulid Temperature Converter application with Html, Css, JavaScript. This application is lots of functionality.',
      video: null,
      images: {
        default: '/Asset/portfolio/tempracher.png',
        variants: [
          '/Asset/portfolio/tempracher.png',
          '/Asset/portfolio/tempracher.png',
        ],
      },
      link: 'https://mosabbirahamed.github.io/Temperature-Converter/',
      source:'https://github.com/MosabbirAhamed/Temperature-Converter',
      type: 'Website',
      tags: ['Web Design','Mobile Apps'],
    },
  ],
};
